import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import "../../Vender/css/Destinations.css";

const Agra = () => {
  const [cookies] = useCookies(["token", "user", "id"]);

  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");

  const user_id = cookies.id;

  const handlePayment = async () => {
    if (!amount || !name || !email || !phone_no) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const res = await fetch(
        "/api/payment_details/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: parseFloat(amount) }),
        },
      );

      const data = await res.json();

      const options = {
        key: process.env.RAZORPAY_KEY_ID,
        amount: data.amount,
        currency: data.currency,
        name: "Aacore Resorts And Hospitality Pvt. Ltd.",
        description: "Agra Booking",
        order_id: data.orderId,
        handler: async function (response) {
          await fetch("/api/payment_details/verify-payment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              amount: parseFloat(amount),
              name,
              email,
              phone_no,
              user_id,
            }),
          });
          alert("Payment successful 🎉");
          setShowModal(false);
        },
        prefill: { name, email, contact: phone_no },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert("Payment initialization failed.");
    }
  };

  return (
    <section id="destination">
      <div className="agra py-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item text-light">
              <Link to="/" className="text-light">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active text-light">Agra</li>
          </ol>
        </nav>
      </div>

      <div className="container py-5">
        <h1 className="text-center">Our Hotel Partners in Agra</h1>

        <div className="row justify-content-center">
          {/* Holiday Inn Agra */}
          <div className="col-md-4 mb-4">
            <div className="card">
              <img
                src="/assets/images/holiday-inn-agra.jpg"
                className="card-img-top"
                alt="Holiday Inn Agra"
                style={{ height: "250px", objectFit: "cover" }}
              />
              <div className="card-body">
                <h5 className="card-title">Holiday Inn Agra</h5>
                <p className="card-text">
                  A modern luxury hotel offering comfortable rooms, fine dining,
                  and easy access to the Taj Mahal.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>

          {/* Fairfield by Marriott Agra */}
          <div className="col-md-4 mb-4">
            <div className="card">
              <img
                src="/assets/images/fairfield-agra.jpg"
                className="card-img-top"
                alt="Fairfield by Marriott Agra"
                style={{ height: "250px", objectFit: "cover" }}
              />
              <div className="card-body">
                <h5 className="card-title">Fairfield by Marriott Agra</h5>
                <p className="card-text">
                  A premium business and leisure hotel with elegant interiors,
                  modern amenities, and world-class service.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>

          {/* Howard Plaza The Fern Agra */}
          <div className="col-md-4 mb-4">
            <div className="card">
              <img
                src="/assets/images/howard-plaza-fern-agra.jpg"
                className="card-img-top"
                alt="Howard Plaza The Fern Agra"
                style={{ height: "250px", objectFit: "cover" }}
              />
              <div className="card-body">
                <h5 className="card-title">Howard Plaza The Fern Agra</h5>
                <p className="card-text">
                  A stylish eco-friendly hotel offering luxurious comfort,
                  contemporary rooms, spa facilities and great hospitality.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Book Agra Tour</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  placeholder="Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  className="form-control mb-2"
                  placeholder="Phone"
                  value={phone_no}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Agra;
